import { render, staticRenderFns } from "./BuilderViewer.vue?vue&type=template&id=5673b523"
import script from "./BuilderViewer.vue?vue&type=script&lang=js"
export * from "./BuilderViewer.vue?vue&type=script&lang=js"
import style0 from "./BuilderViewer.vue?vue&type=style&index=0&id=5673b523&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports